export interface SupportTicketPrefill {
  subject?: string
  description?: string
  projectName?: string
}

export const UPGRADE_TICKET_PREFILL: SupportTicketPrefill = {
  subject: 'Plan upgrade request',
  description: "I'd like to upgrade my plan. ",
}

export const SCREENING_ALLOWANCE_TICKET_PREFILL: SupportTicketPrefill = {
  subject: 'More screening credits',
  description: "I've used up my screening allowance and need more. ",
}
